import type { MissionDiscoveryAvailabilityStatus } from '../../api/api.g';

export interface MissionDiscoveryAvailabilityLike {
  canAccept?: boolean;
  isAvailableForDiscovery?: boolean;
  discoveryAvailabilityStatus?: MissionDiscoveryAvailabilityStatus;
}

export const getMissionDiscoveryAvailability = (mission?: MissionDiscoveryAvailabilityLike) => {
  return mission?.isAvailableForDiscovery ?? mission?.canAccept;
};

export const isMissionAvailableForDiscovery = (mission?: MissionDiscoveryAvailabilityLike, fallback = false) => {
  return getMissionDiscoveryAvailability(mission) ?? fallback;
};
